import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Icon } from "@iconify/react";
import ProfileIcon from "../../asset/profile.png";
import sca from "../../asset/she-code-africa-logo.svg";
import hng from "../../asset/hngi7.png";
import cs50 from "../../asset/cs50.png";
import "./about.less";
import { Card, Button } from "antd";
import ExperienceTimeline from "./Milestone/ExperienceTimeline";

const Index = () => {
  return (
    <div className="aboutPageWrapper">
      <div className="aboutWrapper screen-height container bg-white">
        <Header />
        <div className="w-80">
          <div className="flex about-desc">
            <div className="imageWrapper">
              <div className="aboutMe">
                <img src={ProfileIcon} alt="Tefe" />
                <h1>
                  About <span className="textDe">Me</span>
                </h1>
                {/* <p>Hello World <span className='waving'>👋</span>, Welcome to my portfolio</p> */}
              </div>

              {/* <div className='buttonWrapper'>
            <Button className='portfolioBtn'>Portfolio <Icon icon="gg:arrow-long-right" width="18" className='icon' /></Button>
            <Button className='cvBtn'>Download CV <Icon icon="gg:arrow-long-down" width="18" className='icon' /></Button>
            </div> */}
            </div>
            <div className="summary">
              <p>
                Enthusiastic frontend engineer with over 3 years of experience,
                passionate about writing clean and re-useable code for building
                and maintaining responsive user interface. Proficient in HTML5,
                CSS3, JavaScript, ReactJs, AngularJS plus other modern libraries
                and framework. Passionate about learning, growth oriented,
                effective communicator, collaborative and resourceful.
              </p>
              <div className='expreienceBtnWrap'>
            <Button className='secondaryBtn' href="#experience">My Experience <Icon icon="gg:arrow-long-down" width="18" className='icon' /></Button>

              </div>
            </div>
          </div>
          <div className="flex">
        {/* <Button className='cvBtn'>Experience<Icon icon="gg:arrow-long-down" width="18" className='icon' /></Button> */}

          </div>
        </div>
      </div>
      <div className="glass-container container"></div>
      <div className="experience" id="experience">
        <div>
          <h2 className="text-center">Work Experience</h2>
          <ExperienceTimeline />
        </div>
      </div>
      <div className="glass-container container"></div>
      <div className="bg-black container">
        <div className="technicalSkill">
          <h2>Technical Skill</h2>
          <div className="flex">
            <div className="icon">
              <Icon
                className="img"
                icon="ri:reactjs-line"
                color="white"
                width="50"
              />
              <p>Reactjs</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="akar-icons:redux-fill"
                color="white"
                width="50"
              />
              <p>Redux</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="teenyicons:javascript-outline"
                color="white"
                width="50"
              />
              <p>JavaScript</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="fontisto:angularjs"
                color="white"
                width="50"
              />
              <p>AngularJS</p>
            </div>
          </div>
          <div className="flex">
            <div className="icon">
              <Icon
                className="img"
                icon="fontisto:jquery"
                color="white"
                width="50"
              />
              <p>Jquery</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="bi:bootstrap"
                color="white"
                width="50"
              />
              <p>Bootstrap</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="simple-icons:antdesign"
                color="white"
                width="50"
              />
              <p>ANTD</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="icon-park-outline:html-five"
                color="white"
                width="50"
              />
              <p>HTML5</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="ion:logo-css3"
                color="white"
                width="50"
              />
              <p>CSS3</p>
            </div>
            <div className="icon">
              <Icon
                className="img"
                icon="fontisto:nodejs"
                color="white"
                width="50"
              />
              <p>NodeJs</p>
            </div>
          </div>
        </div>
        {/*  */}
      </div>
      <div className="cert">
        <div className="container bg-white ">
          <div className="softSkill summary">
            <h2>Certifications</h2>
            <div className="flex">
              <a
                href="https://drive.google.com/file/d/1bfEHPVnetdYB_4ZFJWKfSAAiwo-h4UbE/view"
                target="_blank"
                rel="noreferrer"
              >
                <Card className="icon a">
                  <img
                    className="img"
                    src={sca}
                    alt="she code africa"
                    style={{ width: "20px" }}
                  />
                  <br />
                  <small>She Code Africa</small>
                </Card>
              </a>
              <a
                href="https://adscerts.com/scholar/B839D049FEE11D73"
                target="_blank"
                rel="noreferrer"
              >
                <Card className="icon b">
                  <Icon className="img" icon="logos:google-developers" />
                  <br />
                  <small>GADS - Google Africa Developer Training Program</small>
                </Card>
              </a>
              <a
                href="https://drive.google.com/file/d/10HfVtGYD3OzjeYIBraONg06D9iYE3zS4/view"
                target="_blank"
                rel="noreferrer"
              >
                <Card className="icon a">
                  <img
                    className="img"
                    src={hng}
                    alt="HNGi7"
                    style={{ width: "20px" }}
                  />
                  <br />
                  <small>HNGi7</small>
                </Card>
              </a>
              <a
                href="https://certificates.cs50.io/828e5473-f76c-4453-869a-1cafdf3b689b.pdf?size=letter"
                target="_blank"
                rel="noreferrer"
              >
                <Card className="icon b">
                  <img
                    className="img"
                    src={cs50}
                    alt="CS50"
                    style={{ width: "20px" }}
                  />
                  <br />
                  <small>CS50 - Introduction to Computer Science from Harvard</small>
                </Card>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Index;
